export const generateDataTestId = (str) => {
  return str.replace(/\s+/g, '-').toLowerCase();
};
